<template>
  <div class="rgbSettings lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="rgbSettings-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="rgbSettings-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.RelaySSR2ASettings_text1}}
        </template>
        <template v-slot:body>
          <div class="rgbSettings-wrapper-RGBWWidget">
            <div style="height: 15px;" class="lxn-w100">
            </div>
            <div class="rgbSettings-RGBWWidget-wrapper-d1 lxn-circle lxn-overflow-hidden lxn-margin-auto" :style="shadowStyle">
              <ButtonIcon :size="40" :bgColor="rgbBgColor" icon="turnOff" :iconColor="rgbIconColor" :padding="14" :isRound="true" />
            </div>
          </div>
        </template>
      </TitleBox>
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.Node9Settings_hue}}
        </template>
        <template v-slot:body>
          <div class="rgbSettings-wrapper-fieldTitles lxn-w100 lxn-text" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
            {{$store.getters.language.texts.Node9Settings_colorPickerType}}
          </div>
          <DropDown v-model="colorPickerType" :dropDownContex="dropDownColorPickerType" />
          <div style="width: 200px;margin-top: 20px;" class="lxn-margin-auto">
            <div id="lxn-color-picker"></div>
          </div>
        </template>
      </TitleBox>
      <TitleBox :titleBgColor="titleBgColor" bgColor="#ECECEC">
        <template v-slot:title>
          {{$store.getters.language.texts.Node9Settings_rgb}}
        </template>
        <template v-slot:body>
          <div style="width: 200px;" class="lxn-margin-auto">
            <div class="rgbSettings-wrapper-fieldTitles lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Node9Settings_red}}
            </div>
            <div id="lxn-color-picker-r"></div>
            <div class="rgbSettings-wrapper-fieldTitles lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Node9Settings_green}}
            </div>
            <div id="lxn-color-picker-g"></div>
            <div class="rgbSettings-wrapper-fieldTitles lxn-w100 lxn-text lxn-text-center" :class="[$store.getters.language.font, $store.getters.language.directionClass]">
              {{$store.getters.language.texts.Node9Settings_blue}}
            </div>
            <div id="lxn-color-picker-b"></div>
          </div>
        </template>
      </TitleBox>
    </div>
    <div class="rgbSettings-button lxn-margin-auto lxn-w100">
      <CustomButton @click="goBack" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.LoginRegister_back}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import CustomButton from '@/components/CustomButton.vue'
import TitleBox from '@/components/TitleBox.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'
import Messaging from '@/statics/messaging.js'
import Logger from '@/statics/logger.js'
import * as CONFIGS from '@/statics/configs.js'
import NODE11 from '@/statics/devices/Node11/header.js'
import iro from '@jaames/iro';
import DropDown from '@/components/DropDown.vue'

export default {
  name: 'rgbSettings',
  components: {
    CustomCurve,
    TopNav,
    CustomButton,
    TitleBox,
    ButtonIcon,
    DropDown,
  },
  data: function () {
    var node = this.$store.getters.getNodeByUUID(this.$route.params.nodeUUID);

    return {
      node: node,
      shadowBlur: 15,
      colorPicker: null,
      colorPicker_r: null,
      colorPicker_g: null,
      colorPicker_b: null,
      colorChangeTimeoutHandle: -1,
      debounceDelay: 100,
      color: {
        hue: 0,
        saturation: 0,
        value: 0,
      },
      colorLocked: false,
      colorPickerType: 0,
    }
  },
  mounted: async function () {
    this.$store.commit('setAppBusy', true);
    var messagingHook = new Messaging(new Logger(false));
    messagingHook.init({
      psk: this.hub.psk,
      destinationUUID: this.hub.uuid,
      sourceUUID: this.$store.state.user.uuid
    });
    var errorHappened = false;
    try {
      var nodeParameters = await this.$store.dispatch('readNodeParameters', {messagingHook: messagingHook,hubUUID: this.hub.uuid,nodeUUID: this.node.uuid});
      nodeParameters = nodeParameters.body.bodyContent.parameterList;
      this.$store.dispatch('processNodeParameters', {rawParameters: nodeParameters, nodeUUID: this.node.uuid});
      this.$store.commit('setHubStatus', {
        hubIndex: this.hub.index,
        stateUpdateEnabled: true,
      });
      this.$store.commit('setAppBusy', false);
    }
    catch (response) {
      errorHappened = true;
      if(response.rejectCode == 2){
        this.$store.commit('setHubStatus', {
          hubIndex: response.hubIndex,
          connectionStatus: {
            local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
            online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
          },
        });
      }
      alert(this.$store.getters.language.texts.Node9Settings_alert1);
      this.$router.push('/home/devices/')
      this.$store.commit('setAppBusy', false);
    }
    if(errorHappened){
      return;
    }
    this.colorPicker = new iro.ColorPicker("#lxn-color-picker", {
      width: 200,
      borderWidth: 5,
      layout: [
        { 
          component: iro.ui.Wheel,
        },
        { 
          component: iro.ui.Slider,
        },
      ]
    });
    this.colorPicker_r = new iro.ColorPicker("#lxn-color-picker-r", {
      width: 200,
      borderWidth: 5,
      color: "#F00",
      layout: [
        { 
          component: iro.ui.Slider,
          options: {
            sliderType: "value",
          }
        },
      ]
    });
    this.colorPicker_g = new iro.ColorPicker("#lxn-color-picker-g", {
      width: 200,
      borderWidth: 5,
      color: "#0F0",
      layout: [
        { 
          component: iro.ui.Slider,
          options: {
            sliderType: "value",
          }
        },
      ]
    });
    this.colorPicker_b = new iro.ColorPicker("#lxn-color-picker-b", {
      width: 200,
      borderWidth: 5,
      color: "#00F",
      layout: [
        { 
          component: iro.ui.Slider,
          options: {
            sliderType: "value",
          }
        },
      ]
    });

    this.colorPicker.color.hsv = this.currentColor;
    this.colorPicker.on('color:change', this.onColorChange);
    
    this.colorPicker_r.color.hsv = {
      h: 0,
      s: 100,
      v: Math.floor((this.colorPicker.color.rgb.r / 255) * 100),
    }
    this.colorPicker_g.color.hsv = {
      h: 120,
      s: 100,
      v: Math.floor((this.colorPicker.color.rgb.g / 255) * 100),
    }
    this.colorPicker_b.color.hsv = {
      h: 240,
      s: 100,
      v: Math.floor((this.colorPicker.color.rgb.b / 255) * 100),
    }
    this.colorPicker_r.on('color:change', this.onColorChange_r);
    this.colorPicker_g.on('color:change', this.onColorChange_g);
    this.colorPicker_b.on('color:change', this.onColorChange_b);
  },
  destroyed: function () {
    this.$store.commit('cancelAllStateUpdates');
    if(this.colorPicker){
      this.colorPicker.off('color:change', this.onColorChange);
    }
    if(this.colorPicker_r){
      this.colorPicker_r.off('color:change', this.onColorChange_r);
    }
    if(this.colorPicker_g){
      this.colorPicker_g.off('color:change', this.onColorChange_g);
    }
    if(this.colorPicker_b){
      this.colorPicker_b.off('color:change', this.onColorChange_b);
    }
  },
  watch: {
    colorPickerType: function (newVal) {
      switch(newVal){
        case 0:
          this.colorPicker.setOptions({
            layout: [
              { 
                component: iro.ui.Wheel,
              },
              { 
                component: iro.ui.Slider,
              },
            ]
          });
          break;
        case 1:
          this.colorPicker.setOptions({
            layout: [
              { 
                component: iro.ui.Slider,
                options: {
                  sliderType: 'hue'
                }
              },
              { 
                component: iro.ui.Box,
              },
            ]
          });
          break;
        case 2:
          this.colorPicker.setOptions({
            layout: [
              { 
                component: iro.ui.Slider,
                options: {
                  sliderType: 'kelvin'
                }
              },
              { 
                component: iro.ui.Slider,
                options: {
                  sliderType: 'value'
                }
              },
            ]
          });
          break;
      }
    },
    currentColor: function (newVal, oldVal) {
      if(JSON.stringify(newVal) !== JSON.stringify(oldVal)){
        if(this.colorPicker){
          this.colorLocked = true;
          this.colorPicker.color.hsv = newVal;
          this.colorPicker_r.color.hsv = {
            h: 0,
            s: 100,
            v: Math.floor((this.colorPicker.color.rgb.r / 255) * 100),
          }
          this.colorPicker_g.color.hsv = {
            h: 120,
            s: 100,
            v: Math.floor((this.colorPicker.color.rgb.g / 255) * 100),
          }
          this.colorPicker_b.color.hsv = {
            h: 240,
            s: 100,
            v: Math.floor((this.colorPicker.color.rgb.b / 255) * 100),
          }
          this.colorLocked = false;
        }
      }
    },
  },
  computed: {
    hub: function () {
      return this.$store.getters.getHubByUUID(this.node.hubUUID);
    },
    titleBgColor: function () {
      return this.$store.state.themeMainColors[this.node.color];
    },
    currentColor: function () {
      var currentHue = this.$store.getters.getParameterValue(this.node.index, NODE11.HUE.PARAMETER_ID);
      var currentSaturation = this.$store.getters.getParameterValue(this.node.index, NODE11.SATURATION.PARAMETER_ID);
      var currentValue = this.$store.getters.getParameterValue(this.node.index, NODE11.BRIGHTNESS.PARAMETER_ID);
      if( currentHue !== undefined && currentSaturation !== undefined && currentValue !== undefined){
        var currentColor = {
          h: Math.floor((currentHue / 65535) * 360),
          s: Math.floor((currentSaturation / 65535) * 100),
          v: Math.floor((currentValue / 65535) * 100),
        }
      }else{
        currentColor = {
          h: 0,
          s: 0,
          v: 0,
        }
      }
      return currentColor;
    },
    isNodeOffline: function () {
      if(this.node.connectionStatus == 1){
        return false;
      }else{
        return true;
      }
    },
    isHubOffline: function () {
      if(this.hub.connectionStatus.local == 2 || this.hub.connectionStatus.online == 2){
        return false;
      }else{
        return true;
      }
    },
    dropDownColorPickerType: function () {
      var dropDownColorPickerType = {
        name: "rgbSettings-ColorPickerType",
        title: this.$store.getters.language.texts.Node9Settings_colorPickerType,
        selectedIndex: this.colorPickerType,
        data: [
          {
            name: 'HS+V',
            icon: 'rgb',
          },
          {
            name: 'H+SV',
            icon: 'rgb',
          },
          {
            name: 'Kelvin',
            icon: 'rgb',
          },
        ]
      };
      return dropDownColorPickerType;
    },
    shadowStyle: function () {
      if(this.colorPicker){
        var shadowSpread = Math.floor(this.colorPicker.color.hsv.v / 10);
        var shadowColor = this.colorPicker.color.hexString;
      }else{
        shadowSpread = 10;
        shadowColor = "#FFFFFF";
      }
      return `box-shadow: 0 0 ${this.shadowBlur}px ${shadowSpread}px ${shadowColor};background-color: ${this.rgbBgColor}`;
    },
    rgbBgColor: function () {
      if(this.colorPicker){
        if(this.colorPicker.color.hsv.v !== 0){
          return "#FFFFFF";
        }else{
          return "#132f45";
        }
      }else{
        return "#FFFFFF";
      }
    },
    rgbIconColor: function () {
      if(this.colorPicker){
        if(this.colorPicker.color.hsv.v !== 0){
          return "#1d394f";
        }else{
          return "#87b4c7";
        }
      }else{
        return "#1d394f";
      }
    },
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    onColorChange: function (color) {
      if(!this.colorLocked){
        this.colorLocked = true;
        this.colorPicker_r.color.hsv = {
          h: 0,
          s: 100,
          v: Math.floor((color.rgb.r / 255) * 100),
        }
        this.colorPicker_g.color.hsv = {
          h: 120,
          s: 100,
          v: Math.floor((color.rgb.g / 255) * 100),
        }
        this.colorPicker_b.color.hsv = {
          h: 240,
          s: 100,
          v: Math.floor((color.rgb.b / 255) * 100),
        }
        this.colorLocked = false;
        clearTimeout(this.colorChangeTimeoutHandle);
        this.colorChangeTimeoutHandle = setTimeout( async () => {
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: false,
          });
          this.color.hue = Math.floor((color.hsv.h / 360) * 65535);
          this.color.saturation = Math.floor((color.hsv.s / 100) * 65535);
          //Math.min is due to a bug in iro.js causing value to be more than 100!
          this.color.value = Math.floor(( Math.min(color.hsv.v, 100) / 100) * 65535);

          var messagingHook = new Messaging(new Logger(false));
          messagingHook.init({
            psk: this.hub.psk,
            destinationUUID: this.hub.uuid,
            sourceUUID: this.$store.state.user.uuid
          });
          try {
            await this.$store.dispatch('setNodesParameters', {
              messagingHook: messagingHook,
              hubUUID: this.hub.uuid,
              nodeUUID: this.node.uuid,
              bodyContent: {
                nodeActions: [
                  {
                    nodeUUID: this.node.uuid,
                    actions: [
                      {
                        parameterId: NODE11.ANIMATION_MODE.PARAMETER_ID,
                        valueOfChange: CONFIGS.RGBW_ANIMATION_NONE,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                      {
                        parameterId: NODE11.HUE.PARAMETER_ID,
                        valueOfChange: this.color.hue,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                      {
                        parameterId: NODE11.SATURATION.PARAMETER_ID,
                        valueOfChange: this.color.saturation,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                      {
                        parameterId: NODE11.BRIGHTNESS.PARAMETER_ID,
                        valueOfChange: this.color.value,
                        typeOfAction: CONFIGS.ACTION_TYPE_SET,
                        timeDelay: 0
                      },
                    ]
                  },
                ]
              }
            })
            console.log("DONE");
          }
          catch (response) {
            console.log(response);
            if(response.rejectCode == 2){
              this.$store.commit('setHubStatus', {
                hubIndex: response.hubIndex,
                connectionStatus: {
                  local: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                  online: CONFIGS.HUB_CONNECTION_STATUS_DISCONNECTED,
                },
              });
            }
          }
          this.$store.commit('setHubStatus', {
            hubIndex: this.hub.index,
            stateUpdateEnabled: true,
          });
        }, this.debounceDelay);
      }
    },
    onColorChange_r: function (color) {
      if(!this.colorLocked){
        this.colorPicker.color.setChannel('rgb', 'r', Math.min(Math.floor((color.hsv.v / 100) * 255)), 100);
      }
    },
    onColorChange_g: function (color) {
      if(!this.colorLocked){
        this.colorPicker.color.setChannel('rgb', 'g', Math.min(Math.floor((color.hsv.v / 100) * 255)), 100);
      }
    },
    onColorChange_b: function (color) {
      if(!this.colorLocked){
        this.colorPicker.color.setChannel('rgb', 'b', Math.min(Math.floor((color.hsv.v / 100) * 255)), 100);
      }
    },
  }
}
</script>

<style>
  .rgbSettings-topCurve-wrapper {
    height: 200px;
  }
  .rgbSettings-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 2;
    background-color: #ffffff;
    margin-bottom: 14px;
    padding: 14px;
  }
  .rgbSettings-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
  .rgbSettings-wrapper-fieldTitles {
    margin-top: 10px;
    height: 20px;
    line-height: 20px;
    color: #52626C;
  }
  .rgbSettings-wrapper-RGBWWidget {
    height: 70px;
  }
  .rgbSettings-RGBWWidget-wrapper-d1 {
    width: 40px;
    height: 40px;
    transition: all 300ms linear;
  }
</style>
